import Checkmark from "@/common/icons/checkmark"
import styles from "@/components/common/form/checkbox.module.css"

export function Checkbox({ checked = false }) {
  return <div className={styles.wrapper}>{checked && <Checkmark />}</div>
}
